import React from 'react';
import Form from './Form';
import Api from '../../api';
import AuthContext from '../../auth-context';
import { LoginInput } from '../../types';
import jwt from 'jwt-decode';

const Auth = () => {
  const { setAuthenticated } = React.useContext(AuthContext);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(false);

  const onSubmit = async (values: LoginInput): Promise<void> => {
    setLoading(true);

    try {
      const response = await Api.login(values);

      if (response.accessToken) {

        const { tableauToken } = jwt(response.accessToken as string) as any;
        localStorage.setItem('token', response.accessToken);
        localStorage.setItem('tableauToken', tableauToken);

        setAuthenticated(true);
      }
    } catch (err) {
      console.log(err);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Form
      onSubmit={onSubmit}
      loading={loading}
      error={error}
    />
  )
};

export default Auth;
